module.exports = (propName) ->
  (->
    photo = @get(propName)
    result = if photo then "background-image:  url(#{photo});" else ''
    result.htmlSafe()
  ).property(propName)